module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('center', [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/to-do.jpg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("A simple vue.js todo web app")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "close-on-press-escape": false,
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', {
    slot: "title"
  }, [_c('center', [_c('h4', [_vm._v("Add New Task")])])], 1), _vm._v(" "), _c('span', [_c('el-form', {
    ref: "taskForm",
    attrs: {
      "model": _vm.aTask,
      "label-position": "top",
      "label-width": "100px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Task",
      "prop": "desc",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Type task here"
    },
    model: {
      value: (_vm.aTask.desc),
      callback: function($$v) {
        _vm.aTask.desc = $$v
      },
      expression: "aTask.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14,
      "offset": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "due",
      "label": "Due date",
      "required": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check),
      expression: "check"
    }],
    staticClass: "error"
  }, [_vm._v("Due date is passed")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Pick a date"
    },
    on: {
      "change": _vm.checkDue
    },
    model: {
      value: (_vm.aTask.due),
      callback: function($$v) {
        _vm.aTask.due = $$v
      },
      expression: "aTask.due"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('center', [(_vm.procAdd) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.procAdd
    }
  }, [_vm._v("Adding")]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.check
    },
    on: {
      "click": function($event) {
        _vm.addTask(_vm.aTask)
      }
    }
  }, [_vm._v("Add Task")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 7,
      "lg": 7
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Uncompleted Tasks",
      "name": "first"
    }
  }, [_c('center', {
    staticClass: "space"
  }, [(_vm.totalPending) ? _c('h5', {
    staticClass: "title"
  }, [_vm._v("Pending Tasks ( "), _c('small', [_vm._v(_vm._s(_vm.totalPending))]), _vm._v(" )")]) : _c('h5', {
    staticClass: "title"
  }, [_vm._v("No pending tasks")])]), _vm._v(" "), _c('ul', {
    staticClass: "task-list scroll"
  }, _vm._l((_vm.getPendingTasks), function(tsk, index) {
    return _c('li', {
      key: tsk.desc,
      staticClass: "task"
    }, [_c('p', [_vm._v("\n                " + _vm._s(tsk.desc) + ", "), _c('small', [_c('i', [_vm._v(_vm._s(_vm.dateCreated(tsk.created)))])]), _vm._v(" "), _c('br')]), _c('div', [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dateDue(tsk.due)))]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Click to complete Task",
        "placement": "top"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "success",
        "size": "mini",
        "icon": "check"
      },
      on: {
        "click": function($event) {
          _vm.compTask(tsk)
        }
      }
    })], 1), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Click to Delete Task",
        "placement": "top"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.delTaskP(tsk)
        }
      }
    })], 1)], 1)]), _vm._v(" "), _c('p')])
  }))], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Completed Tasks",
      "name": "second"
    }
  }, [_c('center', {
    staticClass: "space"
  }, [(_vm.totalDone) ? _c('h5', {
    staticClass: "title"
  }, [_vm._v("Tasks Completed ( "), _c('small', [_vm._v(_vm._s(_vm.totalDone))]), _vm._v(" )")]) : _c('h5', {
    staticClass: "title"
  }, [_vm._v("No Tasks Completed")])]), _vm._v(" "), _c('ul', {
    staticClass: "task-list scroll"
  }, _vm._l((_vm.getCompletedTasks), function(tsk) {
    return _c('li', {
      key: tsk.desc,
      staticClass: "task"
    }, [_c('p', [_vm._v("\n                " + _vm._s(tsk.desc) + ", "), _c('small', [_c('i', [_vm._v(_vm._s(_vm.dateCreated(tsk.created)))])]), _vm._v(" "), _c('br')]), _c('div', [_c('i', {
      staticClass: "el-icon-date"
    }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dateDue(tsk.due)))]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Click to complete Task",
        "placement": "top"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "success",
        "size": "mini",
        "icon": "plus"
      },
      on: {
        "click": function($event) {
          _vm.reAddTask(tsk)
        }
      }
    })], 1), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Click to Delete Task",
        "placement": "top"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.delTaskP(tsk)
        }
      }
    })], 1)], 1)]), _vm._v(" "), _c('p')])
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Click to Add Task",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "fab",
    attrs: {
      "type": "success",
      "icon": "plus",
      "native-type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57fe4380","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Todo.vue
// module id = 198
// module chunks = 1